import * as React from "react";
import { getMasterOrgs, getPositions, getReturnWarehouses, getSerialStatuses } from "../api/returnInwardApi";
import type { MasterOrg } from "../api/returnInwardApi";
import { RETURN_WAREHOUSE_CODE_PARTS } from "../config/returnKinds";
import type { PositionOption, WarehouseOption } from "../types";

interface UseReturnLookupsArgs {
  /** Chi nhánh của đơn (toBranchId) để lấy danh sách kho */
  branchId: number | null | undefined;
  /** Kho đang chọn để lấy danh sách vị trí */
  invId: number | null | undefined;
  /** Chỉ loại phiếu chọn kho mới cần danh sách kho */
  pickWarehouse: boolean;
}

/** Danh mục của trang: chi nhánh, tình trạng serial, kho của chi nhánh, vị trí của kho đang chọn */
export const useReturnLookups = ({ branchId, invId, pickWarehouse }: UseReturnLookupsArgs) => {
  const [masterOrgs, setMasterOrgs] = React.useState<MasterOrg[]>([]);
  const [serialStatuses, setSerialStatuses] = React.useState<string[]>([]);
  const [warehouses, setWarehouses] = React.useState<WarehouseOption[]>([]);
  const [positions, setPositions] = React.useState<PositionOption[]>([]);
  const [positionsInvId, setPositionsInvId] = React.useState<number | null>(null);

  React.useEffect(() => {
    getMasterOrgs().then(setMasterOrgs);
    getSerialStatuses().then(setSerialStatuses);
  }, []);

  React.useEffect(() => {
    if (!pickWarehouse || !branchId) {
      setWarehouses([]);
      return undefined;
    }
    let cancelled = false;
    getReturnWarehouses(branchId, RETURN_WAREHOUSE_CODE_PARTS).then((list) => {
      if (!cancelled) setWarehouses(list);
    });
    return () => {
      cancelled = true;
    };
  }, [branchId, pickWarehouse]);

  React.useEffect(() => {
    if (!invId) {
      setPositions([]);
      setPositionsInvId(null);
      return undefined;
    }
    let cancelled = false;
    getPositions(invId).then((list) => {
      if (cancelled) return;
      setPositions(list);
      setPositionsInvId(invId);
    });
    return () => {
      cancelled = true;
    };
  }, [invId]);

  // Vị trí chỉ dùng khi đúng là của kho đang chọn (tránh hiện vị trí kho cũ trong lúc tải)
  const positionsLoaded = positionsInvId === (invId ?? null);

  return { masterOrgs, serialStatuses, warehouses, positions: positionsLoaded ? positions : NO_POSITIONS, positionsLoaded };
};

/** Mảng rỗng cố định để lưới không dựng lại cấu hình cột mỗi lần render */
const NO_POSITIONS: PositionOption[] = [];
